import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'servicos/licitacoes-comunicados',
		component: Base,
		children: [
			{
				path: '',
				name: 'LicitacoesComunicadosList',
				component: List,
				meta: {
					path: '/servicos/licitacoes-comunicados',
					pai: 'Serviços',
					title: 'Admin - Licitações Comunicados',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Licitações Comunicados',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'LicitacoesComunicadosNovo',
				component: Form,
				meta: {
					path: '/servicos/licitacoes-comunicados',
					pai: 'Serviços',
					title: 'Admin - Licitações Comunicados - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Licitações Comunicados',
						class: '',
						active: false,
						url: '/servicos/licitacoes-comunicados'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'LicitacoesComunicadosEditar',
				component: Form,
				meta: {
					path: '/servicos/licitacoes-comunicados',
					pai: 'Serviços',
					title: 'Admin - Licitações Comunicados - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Licitações Comunicados',
						class: '',
						active: false,
						url: '/servicos/licitacoes-comunicados'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]